<template>
  <!-- 第二步：申报项目基本信息 -->
  <div class="teamInfo">

    <el-dialog
        title="添加骨干人员"
        :visible.sync="dialogVisible"
        width="840"
        :before-close="handleClose"
    >
      <el-form
          :model="form"
          :rules="rules"
          ref="form"
          label-width="100px"
          class="demo-form"
      >
        <div class="flex">
          <el-form-item label="姓名" prop="realName">
            <el-input v-model="form.realName" :style="`width: ${widthInput}px`"></el-input>
          </el-form-item>
          <el-form-item label="职称" prop="title">
            <el-select v-model="form.title" placeholder="请选择" clearable :style="`width: ${widthInput}px`">
              <el-option
                  v-for="item in sectorList"
                  :key="item.uuid"
                  :label="item.name"
                  :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="flex">
          <el-form-item label="学历" prop="education">
            <el-select v-model="form.education" placeholder="请选择" clearable :style="`width: ${widthInput}px`">
              <el-option
                  v-for="item in educationList"
                  :key="item.uuid"
                  :label="item.name"
                  :value="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="专业" prop="major">
            <el-input v-model="form.major" :style="`width: ${widthInput}px`"></el-input>
          </el-form-item>
        </div>
        <div class="">
          <el-form-item label="业务专长" prop="speciality">
            <el-input type="textarea" maxlength="300" show-word-limit :autosize="{ minRows: 2, maxRows: 10}" v-model="form.speciality" style="width:100%"></el-input>
          </el-form-item>

        </div>
        <div class="">
          <el-form-item label="个人简介" prop="profile">
            <el-input type="textarea" maxlength="300" show-word-limit :autosize="{ minRows: 2, maxRows: 10}" v-model="form.profile" style="width:100%"></el-input>
          </el-form-item>

        </div>


        <div class="flex">
          <el-form-item  label="附件上传" prop="attachNamePlan" style="width:100%">
            <el-upload
                class="avatar-uploader"
                action="/service-center/api/v1/upload/file/single"
                :file-list="fileList"
                :headers="headers"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                accept=".jpg,.jpeg,.png, .JPG,.JPEG,.PBG,.GIF,.BMP"
                :on-remove="handleRemoveFile"
                :before-upload="beforeAvatarUpload"
                :on-error="handleFileError"
                :on-success="handleFileSuccess">
              <i class="el-icon-plus"></i>
            </el-upload>
            <span class="red" v-if="fileList.length == 0">
              *未选择任何文件 注意：单个附件大小不能超过2M，支持多张图片，学历证明，职称证书，png、jpg等图片格式，清晰。
            </span>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')"
        >确 定</el-button
        >
      </span>
    </el-dialog>
    <div class="" style="font-size: 13px;margin-bottom: 10px">
      <span style="color: red;">*</span><span style="margin-left: 5px;">对核心骨干5-10人进行详细介绍</span>
    </div>
    <el-table :data="tableData" style="width: 100%" border>
      <el-table-column
          v-for="(item, index) in headList"
          :key="index"
          :prop="item.value"
          :label="item.label"
          :width="item.width"
          :align="align"
      >
      </el-table-column>
      <el-table-column prop="indexCompany" label="操作" align="center" width="140" v-if="!disabled">
        <template slot-scope="scope">
          <div class="flex">
            <el-button v-if="!disabled"  type="primary" size="mini" @click="editIndex(scope.row, scope.$index)" :disabled="disabled">编辑</el-button>
            <el-button v-if="!disabled"  type="danger" size="mini" @click="deleteIndex(scope)" :disabled="disabled">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: center;margin-top: 20px;">
      <el-button v-if="!disabled"  type="primary" @click="addIndex" size="mini" :disabled="disabled">新增</el-button>
      <!-- <el-button
        v-show="tableData.length > 1"
        type="danger"
        @click="deleteIndex"
        :disabled="disabled"
      >删除指标</el-button>-->
    </div>
    <el-dialog :visible.sync="imgDialogVisible" class="img-dialog">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import { saveServiceProviderSecondInfo, getServiceProviderSecondInfo } from "../../utils/interface";
import {addProductConsult} from "../../utils/product";
/* 是否是正数 */
const straight = (rule, value, callback) => {
  // console.log(rule, value);
  if (!value) {
    callback(new Error(rule.message));
  }
  let reg = /^\d+(?=\.{0,1}\d+$|$)/;
  if (!reg.test(value)) {
    callback(new Error());
  }
  callback();
};
const form = () => {
  return {
    attachNamePlan:'',
    profile:'',
    speciality:'',
    realName:'',
    title:'',
    education:'',
    major:'',
    attachPlan:[],
  };
};
const rules = () => {
  return {
    realName: [
      { required: true, message: "请输入姓名", trigger: "blur" }
    ],
    title: [
      { required: true, message: "请选择职称", trigger: "blur" }
    ],
    education: [{ required: true, message: "请选择学历", trigger: "blur" }],
    projectDirection: [
      { required: true, message: "请输入项目方向", trigger: "blur" }
    ],
    major: [
      { required: true, message: "请选择专业", trigger: "change" }
    ],
    speciality: [
      { required: true, message: "请输入业务专长", trigger: "blur" }
    ],
    profile: [
      { required: true, message: "请输入个人简介", trigger: "blur" }
    ],
    attachNamePlan: [
      { required: true, message: "请上传附件", trigger: "blur" }
    ]
  };
};
export default {
  name: "",
  components: {},
  props: {
    uuid: String
  },
  data() {
    return {
      editIndexRow: -1, // 当前编辑行的索引
      headList: [
        { label: "姓名", value: "realName",width: 120 },
        { label: "职称", value: "title",width: 120 },
        { label: "学历", value: "education",width: 120 },
        { label: "专业", value: "major",width: 120 },
        { label: "业务特长", value: "speciality" },
      ],
      align: {
        type: String,
        default: "center"
      },
      headers: {
        Authorization: "Bearer " + this.$cookies.get("api_access_token") //	可以是授权凭证用的参数值
      },
      widthInput: 300,
      dialogVisible: false,
      form: form(),
      // 助理工程师、中级工程师、副高级工程师、正高级工程师
      sectorList: [{
        name: "无",
        value: "无"
      },{
        name: "助理工程师",
        value: "助理工程师"
      },
        {
          name: "中级工程师",
          value: "中级工程师"
        },{
          name: "副高级工程师",
          value: "副高级工程师"
        },{
          name: "正高级工程师",
          value: "正高级工程师"
        }],
      // 专科、本科、硕士、博士
      educationList: [{
        name: "专科",
        value: "专科"
      },
        {
          name: "本科",
          value: "本科"
        },{
          name: "硕士",
          value: "硕士"
        },{
          name: "博士",
          value: "博士"
        }],
      dialogImageUrl: '',
      imgDialogVisible: false,
      fileList: [],
      rules: rules(),
      indexForm: {
        cost: "", // 降低企业成本
        defective: "", // 降低不良品率
        efficient: "", // 提高生产运营效率
        utilization: "" // 提高能源利用率
      }, // 4个指标，至少填2个
      tableData: [],
      disabled: false,
      unitUuid: "", // 本步骤的uuid
      showFile: false
    };
  },
  watch: {
    "form.buildDate"(val) {
      if (val) {
        this.form.startDate = val[0];
        this.form.endDate = val[1];
      } else {
        this.form.startDate = "";
        this.form.endDate = "";
      }
      // console.log(val, this.form)
    },
    // "uuid"(val){
    //   if(val){
    //     this.unitUuid = val;
    //     console.log("unitUuid",val);
    //   }
    // }
  },
  computed: {},
  created() {},
  mounted() {
    if (this.$route.query.uuid) {
      console.log('第两步')
      this.getServiceProviderSecondInfo(this.$route.query.uuid);
    }
  },
  methods: {
    handleClose() {
      this.form=form();
      this.editIndexRow = -1; // 重置编辑行索引
      this.dialogVisible = false;
    },
    handlePictureCardPreview(file) {
      console.log("预览。。",file);
      this.dialogImageUrl = file.url;
      this.imgDialogVisible = true;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.fileList && this.fileList.length > 0){
            this.form.attachPlan = [];
            this.fileList.forEach(items => {
              this.form.attachPlan.push({
                path: items.url || items.path,
                name: items.name,
              });
            })
          }
          this.handleSubmitForm();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleSubmitForm() {
      if (this.editIndexRow === -1) {
        // 新增模式
        this.tableData.push({ ...this.form });
      } else {
        // 编辑模式
        this.$set(this.tableData, this.editIndexRow, { ...this.form });
      }
      this.handleClose();
    },
    // 模板附件
    handleFileSuccess(res, file) {
      this.fileList.push(res);
      this.form.attachNamePlan = res.name;
    },
    handleRemoveFile(file, fileList) {
      this.fileList = fileList;
    },

    handleFileError(err, file, fileList) {
      this.$message.error(err);
    },
    /* 新增指标 */
    addIndex() {
      // this.tableData.push({
      //   indexName: "",
      //   indexValue: "",
      //   indexCompany: ""
      // });
      this.form = form();
      this.fileList = [];
      this.editIndexRow = -1; // 重置编辑行索引
      this.dialogVisible = true;
    },
    // 新增编辑方法
    editIndex(row, index) {
      this.form = { ...row }; // 复制当前行数据到表单
      this.fileList = row.attachPlan?row.attachPlan.map(items => {
        return {
          ...items,
          url: items.path || items.url,
        }
      }) : [];
      this.editIndexRow = index; // 记录编辑行索引
      this.dialogVisible = true;
    },
    /* 删除指标 */
    deleteIndex(row) {
      // if (this.tableData.length == 1) {
      //   this.$message.warning("请至少保留一条指标！");
      //   return;
      // }
      this.$confirm("确认删除该条吗！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.tableData.splice(row.$index, 1);
      });
    },
    /* 获取第二步详情 */
    getServiceProviderSecondInfo(uuid) {
      getServiceProviderSecondInfo({unitUuid: uuid}).then(res => {
        if (res.success && res.data.length > 0) {
          this.form = res.data;
          this.form.buildDate = [this.form.startDate, this.form.endDate];
          this.disabled =
            this.$route.query.status == "1" ||
            this.$route.query.status == "4"
              ? false
              : true;
          this.tableData = res.data;
          this.uuid = res.data.uuid;
          this.showFile = true;
        } else {
          this.form = form();
          this.indexForm = {
            cost: "",
            defective: "",
            efficient: "",
            utilization: ""
          };
          // this.tableData = [
          //   { indexName: "", indexValue: "", indexCompany: "" }
          // ];
        }
      });
    },
    /* 第二步保存 */
    save() {
      console.log('uuid---step-2',this.uuid)
      const sum = this.tableData.length;
          // if (sum < 5) {   todo
          if (sum < 5) {
            this.$message({
              message: "团队人员至少填写5条！",
              type: "warning"
            });
            return;
          }
          const list = this.tableData.map(item=>{
            return {
              ...item,
              unitUuid:this.$route.query.uuid || this.uuid,
            }
          });
          saveServiceProviderSecondInfo(list).then(res => {
            if (res.success) {
              this.$message({
                message: res.message,
                type: "success"
              });
              this.uuid = res.data.uuid;
              this.$parent.activeStep++;
            } else {
              this.$message({
                message: res.message,
                type: "error"
              });
            }
          });
    },
    beforeAvatarUpload(file) {
      const isImage = file.type.startsWith('image/');
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      let isLt10M = file.size / 1024 / 1024 < 10;
      let fileNameLength = file.name.length <= 100;
      // this.fileName = file.name
      let fileName = file.name.lastIndexOf(".");
      const fileNameLen = file.name.length;
      const fileTypeName = file.name.substring(fileName, fileNameLen);
      if (!isLt10M) {
        this.$alert("文件大小不能超过10M", "提示", {
          confirmButtonText: "确定"
        });
      } else if (!fileNameLength) {
        this.$alert("文件名（包含后缀名）的最大长度不能超过100个字符", "提示", {
          confirmButtonText: "确定"
        });
      }
      return isLt10M && fileNameLength;
    },
    handleAvatarSuccess(res) {
      if (res) {
        this.form.file = res.url;
        this.form.fileName = res.fileName;
        this.showFile = false;
        this.$message({
          showClose: true,
          message: "上传成功",
          type: "success"
        });
        // console.log(this.form)
      }
    },
    removeFile() {
      this.form.file = "";
      this.form.fileName = "";
      console.log(this.form);
    },
    /* 下载文件 */
    downloadFile(url, name) {
      fetch(url).then(res => {
        res.blob().then(blob => {
          const blobUrl = window.URL.createObjectURL(blob);
          // 这里的文件名根据实际情况从响应头或者url里获取
          const filename = name;
          const a = document.createElement("a");
          a.href = blobUrl;
          a.download = filename;
          a.click();
          window.URL.revokeObjectURL(blobUrl);
        });
      });
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";

.teamInfo {
  min-height: 300px;
  margin-bottom: 35px;
  border-radius: 12px;

  .w350 {
    width: 350px;
  }

  .downFile {
    display: inline-flex;
    height: 40px;
    align-items: center;
    box-sizing: border-box;
    font-size: 14px;
    color: @basic-colors;
    cursor: pointer;
    text-decoration: underline;
  }

  .form-wrap {
    padding: 10px 20px;
    .bs();

    p {
      font-size: 14px;
      color: #888888;
      line-height: 1.7;
      margin-bottom: 40px;
    }

    .iploadInput {
      display: inline-flex;
      /deep/ .el-upload {
        align-self: start;
      }
    }

    .form-title {
      font-size: 14px;
      font-weight: bold;
      margin: 0 0 30px 0px;
      position: relative;
      color: #535353;

      &::before {
        position: absolute;
        content: "";
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background-color: #000;
        top: 50%;
        left: -8px;
        transform: translateY(-50%);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/providerApply/teamInfo.vue